module.exports = __webpack_public_path__ + "static/media/acconsulting.e6178312.svg";